import React from 'react';
import styled from 'styled-components';

const DefaultButton = styled.button`
  display: block;
  width: 100%;
  height: 45px;
  border-radius: 80px;
  font-family: 'Speedee Bold';
  font-size: 18px;
  font-weight: bold;
  line-height: 26px;
  text-align: center;
  box-sizing: border-box;
  background: #FFBC0D;
  box-shadow: inset 0px -4px 0px rgba(0, 0, 0, 0.12);
  border: none;
  outline: none;
  color: #2D2D2D;
  padding: 0;

  &:hover {
    border-top: 2px solid #FFFFFF;
    box-shadow: none;
  }
`;

const SimpleButton = styled.button`
  display: block;
  width: 100%;
  height: 45px;
  border-radius: 80px;
  font-family: 'Speedee Bold';
  font-size: 18px;
  font-weight: bold;
  line-height: 26px;
  color: #2D2D2D !important;
  text-align: center;
  box-sizing: border-box;
  background: #FFFFFF;
  border: none;
  outline: none;

  &:disabled {
    background: rgba(255, 255, 255, 0.5);
  }
`;

const SecondaryButton = styled.button`
  display: block;
  width: 100%;
  height: 45px;
  border-radius: 80px;
  font-family: 'Speedee Bold';
  font-size: 18px;
  font-weight: bold;
  line-height: 26px;
  color: #2D2D2D !important;
  text-align: center;
  box-sizing: border-box;
  background: #FFFFFF;
  border: 2px solid #2D2D2D;
  outline: none;
  padding: 0;

  &:hover {
    color: #FFFFFF !important;
    background: #2D2D2D;
  }
`;

const Button = ({ ...props }) => {
  const { onClick, children, theme = 'default', disabled } = props;

  return (
    <>
      { theme === 'simple' && (
        <SimpleButton onClick={onClick} disabled={disabled}>
          {children}
        </SimpleButton>
      ) }
      { theme === 'default' && (
        <DefaultButton onClick={onClick} disabled={disabled}>
          {children}
        </DefaultButton>
      ) }
      { theme === 'secondary' && (
        <SecondaryButton onClick={onClick} disabled={disabled}>
          {children}
        </SecondaryButton>
      ) }
    </>
  );
}

export default Button;